// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qn_a bhr_sw bhr_kx bhr_ky","PostDetailRight__brandDaysPosts":"qn_b bhr_sw bhr_kx bhr_ky"};